import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inactive-merchant',
  templateUrl: './inactive-merchant.component.html',
  styleUrls: ['./inactive-merchant.component.css']
})
export class InactiveMerchantComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
